<template>
  <span>
    {{calculeAge}}
  </span>
</template>

<script>
export default {
  props: {
    brithday: {
      required: true,
      type: String
    }
  },
  data () {
    return {}
  },
  computed: {
    calculeAge () {
      let age = this.moment.preciseDiff(this.brithday, this.moment(), true)
      let years = age.years ? age.years : 0
      let months = age.months ? age.months : 0
      return `${years} - ${months}`
    }
  }
}
</script>
